export const PROMO_POPUP_EVENT = 'splendapp:tool-success'
export const PROMO_POPUP_STORAGE_KEY = 'splendappPromoLastShownAt'
export const PROMO_POPUP_SESSION_KEY = 'splendappPromoShownThisSession'
export const PROMO_POPUP_DELAY_MS = 60 * 1000
export const PROMO_POPUP_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000

export function notifyToolSuccess(tool) {
  window.dispatchEvent(new CustomEvent(PROMO_POPUP_EVENT, {
    detail: { tool: tool || 'unknown' }
  }))
}

export function canShowPromoPopup(now = Date.now()) {
  if (sessionStorage.getItem(PROMO_POPUP_SESSION_KEY) === 'yes') return false

  const rawTimestamp = localStorage.getItem(PROMO_POPUP_STORAGE_KEY)
  if (!rawTimestamp) return true

  const timestamp = Number(rawTimestamp)
  if (!Number.isFinite(timestamp)) return true

  return now - timestamp >= PROMO_POPUP_COOLDOWN_MS
}

export function recordPromoPopupImpression(now = Date.now()) {
  localStorage.setItem(PROMO_POPUP_STORAGE_KEY, String(now))
  sessionStorage.setItem(PROMO_POPUP_SESSION_KEY, 'yes')
}
